/* bbb-cart-drawer.js — Beyond Belief Brewing cart drawer.
   Uses the Cart AJAX API + Section Rendering API: mutations return the freshly rendered
   section, and we swap [data-bbb-cart-contents] in place. Progressive: the header cart link
   still points at /cart, so with JS off nothing breaks. */
(function () {
  var SECTION = 'bbb-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('[data-bbb-cart]'); }
  function contents() { return document.querySelector('[data-bbb-cart-contents]'); }

  /* ---- open / close ---- */
  var lastFocus = null;
  function open() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    syncUpsell();
    wireUpsellDots();
    refresh();
    var panel = d.querySelector('.bbb-cart__panel');
    if (panel) panel.focus();
  }
  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---- render helpers ---- */
  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-bbb-cart-contents]');
    var cur = contents();
    if (!next || !cur) return;

    // The Section-Rendering API render can drop the collection-based upsell (group-section
    // settings fall back to schema defaults, and a collection has no default). So we keep the
    // original page-load upsell node and carry it across every swap.
    var keepUpsell = cur.querySelector('[data-bbb-upsell]');
    cur.innerHTML = next.innerHTML;
    if (keepUpsell) {
      var fresh = cur.querySelector('[data-bbb-upsell]');
      if (fresh) {
        fresh.replaceWith(keepUpsell);
      } else if (cur.querySelector('.bbb-cart__items')) {
        var anchor = cur.querySelector('[data-bbb-notes]') || cur.querySelector('.bbb-cart__foot');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(keepUpsell, anchor);
      }
    }

    syncCountFromContents();
    syncUpsell();
    wireUpsellDots();
  }
  function setBusy(on) {
    var d = drawer();
    if (d) d.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function syncCountFromContents() {
    var el = document.querySelector('[data-bbb-cart-count]');
    if (!el) { updateHeaderCount(0); return; }
    var n = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(n)) {
      var m = (el.textContent || '').match(/\d+/);
      n = m ? parseInt(m[0], 10) : 0;
    }
    updateHeaderCount(n);
  }

  function updateHeaderCount(n) {
    var link = document.querySelector('.bbb-header__icon--cart');
    if (!link) return;
    var badge = link.querySelector('.bbb-header__cart-count');
    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bbb-header__cart-count';
        link.appendChild(badge);
      }
      badge.textContent = n;
      badge.style.display = '';
    } else if (badge) {
      badge.style.display = 'none';
    }
  }

  /* ---- cart mutations ---- */
  function post(url, body, isForm) {
    setBusy(true);
    var opts = { method: 'POST' };
    if (isForm) {
      opts.body = body; // FormData
      opts.headers = { 'X-Requested-With': 'XMLHttpRequest' };
    } else {
      opts.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      opts.body = JSON.stringify(body);
    }
    return fetch(ROOT + url, opts)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (res.json && res.json.sections && res.json.sections[SECTION]) {
          swap(res.json.sections[SECTION]);
        }
        setBusy(false);
        return res;
      })
      .catch(function () { setBusy(false); });
  }

  function changeQty(key, qty) {
    return post('cart/change.js', { id: key, quantity: qty, sections: SECTION, sections_url: location.pathname });
  }
  function addVariant(id, qty) {
    return post('cart/add.js', { id: id, quantity: qty || 1, sections: SECTION, sections_url: location.pathname })
      .then(function (res) { if (res) open(); return res; });
  }

  /* refresh contents from the server (on open) */
  function refresh() {
    fetch(ROOT + '?sections=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j[SECTION]) swap(j[SECTION]); })
      .catch(function () {});
  }

  /* ---- order note (debounced, no swap) ---- */
  var noteTimer;
  function saveNote(val) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: val })
      }).catch(function () {});
    }, 500);
  }

  /* ---- upsell: hide products already in the cart, rebuild dots, hide when empty ---- */
  function syncUpsell() {
    var up = document.querySelector('[data-bbb-upsell]');
    if (!up) return;
    var inCart = {};
    document.querySelectorAll('[data-bbb-cart-item]').forEach(function (li) {
      inCart[li.getAttribute('data-product-id')] = true;
    });
    var cards = up.querySelectorAll('[data-bbb-upsell-card]');
    var visible = 0;
    cards.forEach(function (c) {
      var hide = !!inCart[c.getAttribute('data-product-id')];
      c.style.display = hide ? 'none' : '';
      if (!hide) visible++;
    });
    up.style.display = visible > 0 ? '' : 'none';

    var dots = up.querySelector('[data-bbb-upsell-dots]');
    if (dots) {
      dots.innerHTML = '';
      if (visible > 1) {
        for (var i = 0; i < visible; i++) {
          var s = document.createElement('span');
          s.className = 'bbb-cart__upsell-dot' + (i === 0 ? ' is-active' : '');
          dots.appendChild(s);
        }
        dots.style.display = '';
      } else {
        dots.style.display = 'none';
      }
    }
  }

  function wireUpsellDots() {
    var track = document.querySelector('[data-bbb-upsell-track]');
    var up = document.querySelector('[data-bbb-upsell]');
    if (!track || !up || track.__wired) return;
    track.__wired = true;
    track.addEventListener('scroll', function () {
      var vis = Array.prototype.filter.call(up.querySelectorAll('[data-bbb-upsell-card]'), function (c) { return c.style.display !== 'none'; });
      var dots = up.querySelectorAll('[data-bbb-upsell-dots] .bbb-cart__upsell-dot');
      if (!dots.length || !vis.length) return;
      var cardW = vis[0].getBoundingClientRect().width + 12;
      var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / cardW));
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }, { passive: true });
  }

  /* ---- delegated events ---- */
  document.addEventListener('click', function (e) {
    // Open from header cart link (or any tagged trigger)
    var trigger = e.target.closest('[data-bbb-cart-toggle], .bbb-header__icon--cart');
    if (trigger) { e.preventDefault(); open(); return; }

    // Close
    var closer = e.target.closest('[data-bbb-cart-close]');
    if (closer) {
      // Real links (empty-state CTA) must still navigate — only swallow the
      // click for closers that have nowhere to go (overlay, close button).
      var closerHref = closer.getAttribute('href');
      if (!closerHref || closerHref.charAt(0) === '#') e.preventDefault();
      close();
      return;
    }

    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;

    var item = e.target.closest('[data-bbb-cart-item]');

    if (e.target.closest('[data-bbb-qty-inc]') && item) {
      e.preventDefault();
      var incVal = item.querySelector('[data-bbb-qty-val]');
      changeQty(item.getAttribute('data-key'), parseInt(incVal.textContent, 10) + 1);
      return;
    }
    if (e.target.closest('[data-bbb-qty-dec]') && item) {
      e.preventDefault();
      var decVal = item.querySelector('[data-bbb-qty-val]');
      changeQty(item.getAttribute('data-key'), Math.max(0, parseInt(decVal.textContent, 10) - 1));
      return;
    }
    if (e.target.closest('[data-bbb-cart-remove]') && item) {
      e.preventDefault();
      changeQty(item.getAttribute('data-key'), 0);
      return;
    }
    var upBtn = e.target.closest('[data-bbb-upsell-add]');
    if (upBtn) {
      e.preventDefault();
      addVariant(upBtn.getAttribute('data-variant'), 1);
      return;
    }
    var notesToggle = e.target.closest('[data-bbb-notes-toggle]');
    if (notesToggle) {
      e.preventDefault();
      var notes = notesToggle.closest('[data-bbb-notes]');
      var isOpen = notes.classList.toggle('is-open');
      notesToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) close();
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-bbb-note]')) saveNote(e.target.value);
  });

  /* Intercept add-to-cart forms site-wide → add via AJAX + open drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', location.pathname);
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    post('cart/add.js', fd, true).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
      open();
    });
  });

  // Initial header-count sync + upsell filter + dot wiring on load.
  function init() { syncCountFromContents(); syncUpsell(); wireUpsellDots(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
